import { render } from "./ReglesPanneau.vue?vue&type=template&id=6c725304&scoped=true&ts=true"
import script from "./ReglesPanneau.vue?vue&type=script&lang=ts"
export * from "./ReglesPanneau.vue?vue&type=script&lang=ts"

import "./ReglesPanneau.vue?vue&type=style&index=0&id=6c725304&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c725304"]])

export default __exports__